import config from "../config";
var axios = config();

export default {
  getForStudentOpportunity(studentOpportunityId) {
    return axios.get("/api/Goals/GetForStudentOpportunity", {
      params: { studentOpportunityId: studentOpportunityId }
    });
  },
  get(id) {
    return axios.get("/api/Goals/GetById", {
      params: { id: id }
    });
  },
  postCreate(data) {
    return axios.post("/api/Goals/Create", {
      params: { goal: data }
    });
  },
  postCreateAll(data) {
    return axios.post(
      "/api/Goals/CreateMultiple?asuriteId=" + data.asuriteId,
      data.goals
    );
  }
};
